// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"446": "recorder","890": "profiler",}[chunkId] || chunkId) + "." + {"128": "2bcb0554","446": "59ee1c84","592": "0ff088f7","805": "eb76e163","807": "4de85b32","876": "ae285b6d","890": "07149904","968": "52ea2557",}[chunkId] + ".js"
}